import { render, staticRenderFns } from "./JobFullDetails.vue?vue&type=template&id=23ffe61e&"
import script from "./JobFullDetails.vue?vue&type=script&lang=js&"
export * from "./JobFullDetails.vue?vue&type=script&lang=js&"
import style0 from "./JobFullDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports